import { render } from "./TheOptions.vue?vue&type=template&id=0122bd1d&scoped=true"
import script from "./TheOptions.vue?vue&type=script&lang=js"
export * from "./TheOptions.vue?vue&type=script&lang=js"

import "./TheOptions.vue?vue&type=style&index=0&id=0122bd1d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0122bd1d"]])

export default __exports__